module.exports = __webpack_public_path__ + "img/yichadan.92f7f33c.png";